/**
 * Loaded from theme.liquid only on the cart template or when the current URL has ?open_cart_drawer=1.
 * Cart template: redirect to storefront root with ?open_cart_drawer=1 (window.__watkinsCartRedirectUrl set in theme).
 * Other pages: open #component-cart-drawer and strip the param.
 */
(function () {
  var homeWithDrawer = window.__watkinsCartRedirectUrl;
  if (homeWithDrawer) {
    try {
      delete window.__watkinsCartRedirectUrl;
    } catch (e) {
      window.__watkinsCartRedirectUrl = undefined;
    }
    window.location.replace(homeWithDrawer);
    return;
  }

  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('open_cart_drawer') !== '1') return;
    params.delete('open_cart_drawer');
    var qs = params.toString();
    var cleanPath = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;

    function stripQuery() {
      try {
        window.history.replaceState(null, '', cleanPath);
      } catch (e) {}
    }

    function openCartDrawer() {
      var el = document.getElementById('component-cart-drawer');
      if (!el || typeof el.openDrawer !== 'function') return false;
      el.openDrawer(null);
      stripQuery();
      return true;
    }

    function tryOpenWhenReady() {
      if (openCartDrawer()) return;
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('custom-drawer').then(function () {
          if (openCartDrawer()) return;
          var n = 0;
          var id = window.setInterval(function () {
            if (openCartDrawer() || ++n > 80) window.clearInterval(id);
          }, 50);
        });
      } else {
        var n2 = 0;
        var id2 = window.setInterval(function () {
          if (openCartDrawer() || ++n2 > 100) window.clearInterval(id2);
        }, 50);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryOpenWhenReady);
    } else {
      tryOpenWhenReady();
    }
  } catch (e) {}
})();
